<template>
  <div class="tags-view">
    <div class="tags-scroll">
      <div
        v-for="tag in visited"
        :key="tag.fullPath"
        class="tags-item"
        :class="{ 'tags-item--active': tag.fullPath === activeFullPath }"
        @click="onClick(tag)"
      >
        <span class="tags-item-title">{{ tag.title }}</span>
        <button
          v-if="!tag.affix"
          type="button"
          class="tags-item-close"
          aria-label="关闭"
          @click.stop="onClose(tag)"
        >
          ×
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useTagsView } from '@/composables/useTagsView'

const { visited, activeFullPath, closeTab, goTab } = useTagsView()

function onClick(tag) {
  goTab(tag)
}

function onClose(tag) {
  closeTab(tag)
}
</script>

<style scoped>
.tags-view {
  flex: 1;
  min-width: 0;
  background: transparent;
  border-bottom: 0;
  margin: 0;
  padding: 0 4px 0 12px;
}
.tags-scroll {
  display: flex;
  flex-wrap: nowrap;
  gap: 0;
  overflow-x: auto;
  overflow-y: hidden;
  min-height: 44px;
  align-items: stretch;
}
.tags-scroll::-webkit-scrollbar {
  height: 4px;
}
.tags-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 12px;
  font-size: 13px;
  color: #64748b;
  cursor: pointer;
  border-right: 1px solid #f1f5f9;
  white-space: nowrap;
  user-select: none;
  transition: color 0.15s, background 0.15s;
}
.tags-item:hover {
  color: #2563eb;
  background: #f8fafc;
}
.tags-item--active {
  color: #2563eb;
  font-weight: 600;
  background: #eff6ff;
  box-shadow: inset 0 -2px 0 #2563eb;
}
.tags-item-title {
  line-height: 44px;
}
.tags-item-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  margin-left: 2px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #94a3b8;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}
.tags-item-close:hover {
  background: #e2e8f0;
  color: #475569;
}
.tags-item--active .tags-item-close:hover {
  background: #dbeafe;
  color: #1d4ed8;
}
</style>
